import { BaseInput } from '@enter/core';
import { mdiMagnify } from '@mdi/js';
import _ from 'lodash';
import React, { useEffect, useMemo, useRef } from 'react';
import * as S from './patient-collections.styles';

interface Props {
    value: string;
    onChange: (value: string) => void;
    onCommit: (value: string) => void;
}

export const PatientCollectionsSearch: React.FC<Props> = ({ value, onChange, onCommit }) => {
    const onCommitRef = useRef(onCommit);
    onCommitRef.current = onCommit;

    const commit = useMemo(
        () =>
            _.debounce((term: string) => {
                onCommitRef.current(term);
            }, 400),
        [],
    );

    useEffect(() => {
        return () => commit.cancel();
    }, [commit]);

    return (
        <S.HeaderSearch>
            <S.SearchInputWrapper>
                <S.SearchIcon path={mdiMagnify} size="18px" />
                <BaseInput
                    value={value}
                    placeholder="Search by patient ID"
                    onChange={e => {
                        const next = e.target.value;
                        onChange(next);
                        commit(next);
                    }}
                    onKeyDown={e => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            commit.cancel();
                            onCommit(value);
                        }
                    }}
                    onDelete={
                        value
                            ? () => {
                                  onChange('');
                                  commit.cancel();
                                  onCommit('');
                              }
                            : undefined
                    }
                />
            </S.SearchInputWrapper>
        </S.HeaderSearch>
    );
};
